import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import SingleStreetLight from "../../../../features/planBT/components/Streetlight/SingleStreetLight";

export default function SingleStreetLightListPage() {
  const { navigate } = useMicroNavigator();
  return (
    <div style={{ color: "white" }}>
      <HeaderWidget variant={"dark"} handleBackBtn={() => navigate("list")}>
        <SingleStreetLight.Title />
      </HeaderWidget>
      <div style={{marginBottom: '20px'}}>
      <SingleStreetLight.StreetLightNumber />
      </div>
      <div style={{marginBottom: '20px'}}>
      <SingleStreetLight.ZhagaNode />
      </div>
      <SingleStreetLight.PoleName />
    </div>
  );
}
